import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: `amigogaming/game/list`,
  converter,
  gameListUrlData: {
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: { 'x-partner-name': projectName },
    }),
  },
  sessionUrlData: {
    url: 'amigogaming/game/launch',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getBody: params => ({
      game_id: params.gameId,
      // TODO на релизе поменять на паблик роут
      lobby_url: `${params.url}/slots`,
      lang: shortLanguages[params.lang as keyof typeof shortLanguages],
    }),
    getHeaders: () => ({
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
  },
};
